export default __webpack_public_path__ + "static/media/concur_logo.fa350679.png";